import { FC } from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@/utils/tailwind';

import { METRICS_CARD_TEST_IDS } from '../../../constants/data-testids';
import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

type MetricsCardSkeletonProps = {
  size: '1/3' | '2/3' | '3/3';
};

const cardContentVariants = cva('flex flex-col', {
  variants: {
    size: {
      '1/3': 'gap-2',
      '2/3': 'gap-4',
      '3/3': 'gap-[84px]',
    },
  },
  defaultVariants: {
    size: '2/3',
  },
});

export const MetricsCardSkeleton: FC<MetricsCardSkeletonProps> = ({ size }) => {
  return (
    <Card
      data-testid={METRICS_CARD_TEST_IDS.SKELETON}
      className="cursor-pointer border select-none"
    >
      <CardContent className={cn(cardContentVariants({ size }))}>
        <div className="flex items-center justify-between gap-2 min-h-5">
          <Skeleton className="h-[14px] w-[188px] rounded-sm" />
        </div>

        <div className="min-h-[22px] flex items-center gap-2">
          <Skeleton className=" h-[14px] w-[60px] rounded-sm" />
          <Skeleton className=" h-[14px] w-10 rounded-sm" />
        </div>
      </CardContent>
    </Card>
  );
};
